/**
 * My account (container, Phase 7b): who I am and my offline PIN (D20) — set,
 * change or clear it. Setting needs `local.login` somewhere (a node re-checks
 * it for its own site). On a node's page the PIN is the cloud's to set.
 */
import { toast } from 'sonner';
import { useGrants, useOfflinePin, useOfflinePinWrite, useServices, useSession } from '../app/hooks.js';
import { OfflinePinCard } from '../components/admin/OfflinePinCard.js';
import { Card, CardDescription, CardHeader, CardTitle } from '../components/ui/card.js';
import { allowsSomewhere } from '../lib/permissions.js';
import { errorText } from './admin/common.js';

export function AccountView() {
  const services = useServices();
  const session = useSession();
  const grants = useGrants();
  const onNode = services.backend.kind === 'node';
  const pin = useOfflinePin();
  const write = useOfflinePinWrite();
  return (
    <div className="mx-auto grid max-w-3xl gap-4" data-testid="account-page">
      <Card>
        <CardHeader>
          <CardTitle>My account</CardTitle>
          <CardDescription>
            Signed in as {session?.email ?? session?.userId ?? '?'}
            {session?.tenantId === null || session?.tenantId === undefined ? '' : ` in ${session.tenantId}`}.
          </CardDescription>
        </CardHeader>
      </Card>
      {onNode ? (
        <Card data-testid="pin-cloud-only">
          <CardHeader>
            <CardTitle>Offline PIN</CardTitle>
            <CardDescription>Your offline PIN is set in the cloud portal, and reaches this server with its next directory sync.</CardDescription>
          </CardHeader>
        </Card>
      ) : (
        <OfflinePinCard
          status={pin.data ?? null}
          canSet={allowsSomewhere(grants, 'local.login')}
          pending={write.isPending}
          error={errorText(pin.error ?? write.error)}
          onSet={(value) => write.mutate({ pin: value }, { onSuccess: () => toast.success('Offline PIN set') })}
          onClear={() => write.mutate({ pin: null }, { onSuccess: () => toast.success('Offline PIN cleared') })}
        />
      )}
    </div>
  );
}
